import { render, staticRenderFns } from "./wx-landing-page.vue?vue&type=template&id=424281cc&scoped=true"
import script from "./wx-landing-page.vue?vue&type=script&lang=js"
export * from "./wx-landing-page.vue?vue&type=script&lang=js"
import style0 from "./wx-landing-page.vue?vue&type=style&index=0&id=424281cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424281cc",
  null
  
)

export default component.exports